export default {
  minShownDiscount: 10,
  imagesBaseUrl: 'https://loveholidays-images.global.ssl.fastly.net/images/',
  defaultBridgeDate: 1443657600000,
  allFlightOptions: {
    optionsCount: 20,
    linkEveryNthOption: 3,
  },
  paginationDefaults: {
    optionsCount: 10,
    neighborCount: 1,
    startSpreadFromNumberOfPages: 4,
    displayFirst: true,
  },
  maxNumberOfRooms: 3,
  maxRoomGuests: 5,
  // TODO change adultsOptions to string, this will affect HO, FO, search unit, and other mobile stuff that is using it
  adultsOptions: [1, 2, 3, 4, 5],
  childrenOptions: ['0', '1', '2', '3', '4'],
  minChildAge: 0,
  maxChildAge: 17,
  defaultSection: 'description',
  hotelDetailsSections: {
    description: { label: 'Overview' },
    resort: { label: 'Resort Guide' },
    review: { label: 'Reviews' },
    location: { label: 'Location' },
    // qa: { label: 'Q & A' },
    facilities: { label: 'Facilities' },
  },
  maximumCancellationDays: 28,
  numberOfCalendarMonths: 18,
  recoverableErrorMessages: [
    'TNS_3DS_CHECK_FAILED',
    'PAYMENT_SYSTEM_ERROR',
    'TNS_CC_TOKENISATION_FAILED',
  ],
};



/** WEBPACK FOOTER **
 ** ./src/config/global.js
 **/